import type { ProductForCustomer } from "../Product.js";
import type { ProductOption } from "../ProductOption.js";
import type { ProductSize } from "../ProductSize.js";
import { defaultSize } from "../defaultSize.js";
import { productSizeKeyMap } from "../productSizeKeyMap.js";

export function getDefaultSizeForProductForCustomer(
	product: ProductForCustomer,
	selectedOption?: ProductOption,
): ProductSize {
	const availableSizes = product.availableSizes.filter(
		(size: ProductSize) =>
			selectedOption === undefined || product.enabledOptions[productSizeKeyMap[size]].includes(selectedOption),
	);
	const size = availableSizes.includes(defaultSize) ? defaultSize : availableSizes[0];
	if (size === undefined) {
		throw new Error(`Product has no available size.`);
	}
	return size;
}
